<template>
  <div class="applyLoan">
    <!-- 头图 -->
    <div class="headImgs">
      <img src="../../assets/imgs/apply/bg.png" />
    </div>
    <div class="title">
      <img src="../../assets/imgs/apply/title.png" />
      <p>
        信易贷平台专享产品结合大数据精准建模，实现融资需求智能匹配、快速测额、线上授信
      </p>
    </div>
    <div class="main">
      <div class="btn_box">
        <div v-if="$store.state.user.sourceType === '1'">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox
          ><span @click="dialogVisible = true">信用承诺书</span>
        </div>
        <!-- <div
            class="checked"
            v-if="checked"
            @click="onSubmit()"
          >确认申请</div>
          <div
            class="unchecked"
            v-else
          >确认申请</div> -->
        <!-- <div
          :class="selected == index ? 'select' : 'item'"
          v-for="(item,index) in list"
          :key="index"
          @click="banlaceChange(item.id)"
        >{{item.value}}</div> -->
        <!-- <div class="check">
          <img
            src="../../assets/imgs/apply/applyDown.png"
            style="margin-right:25px;"
            @click="banlaceChange(0)"
          >
          <img
            src="../../assets/imgs/apply/applyUp.png"
            style="margin-left:25px;"
            @click="banlaceChange(1)"
          >
        </div> -->
        <div class="bankList" v-for="(item, index) in seachList" :key="index">
          <div class="left">
            <img :src="baseUrl + item.proIcon" />
            <div class="text">{{ item.name }}</div>
          </div>
          <div class="right">
            <div class="child">
              <span class="top"
                >{{ item.interestRateFloor }}-{{ item.interestRateCap }}</span
              >
              <span class="btn">年利率（%）</span>
            </div>
            <div
              class="child"
              style="
                border-left: 1px solid #d5d5d5;
                border-right: 1px solid #d5d5d5;
              "
            >
              <span class="top"
                >{{ item.loanLimitFloor }}-{{ item.loanLimitCap }}</span
              >
              <span class="btn">额度(万元)</span>
            </div>
            <div class="child">
              <span class="top">
                {{ item.minLoanTime }}-{{ item.maxLoanTime }}</span
              >
              <span class="btn">贷款（月）</span>
            </div>
            <el-button
              type="primary"
              style="width: 148px; height: 56px"
              @click="checked == true ? apply(item.id) : none()"
              >立即申请</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <img src="../../assets/imgs/apply/process.png" />
    <el-dialog
      title="信用承诺书"
      :visible.sync="dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :lock-scroll="false"
    >
      <p>一、本单位承诺，提供的所有资料均合法、真实、有效。</p>
      <p>
        二、若发生违法失信行为，本单位将依照有关法律、法规规章和政策规定接受处罚，并依法承担相应责任。
      </p>
      <p>
        三、本单位承诺，如存在弄虚作假或不履行“信易贷”相关工作要求等行为，自愿退出“信易贷”推荐企业名单，自愿接受有关部门依法依规实施失信惩戒。
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agree()">同意</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="success"
      :width="dialogWidth"
      :lock-scroll="false"
      :show-close="false"
      :before-close="handleClose"
      custom-class="successdiolog"
    >
      <div style="display: flex; align-items: center; flex-direction: column">
        <img
          src="../../assets/imgs/apply/随e贷.png"
        />
     
     
        <el-button style="margin-top: 20px" type="primary" @click="getSuccess"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as applyApi from "@/api/apply";
import baseUrl from "@/api/baseUrl";
import {
  detail,
  getDictionaryByCode,
  operate,
  productDetail,
  queryProductHandlingInfo,
  selectApplyCount,
} from "@/api/index";
export default {
  data() {
    return {
      selected: null,
      loanMinAmount: null,
      loanMaxAmount: null,
      checked: false,
      dialogVisible: false,
      status: "",
      seachList: [],

      success: false,
      dialogWidth: "660px",
      Name: "",
      qrCode: "",
      phone: "",
      adressList: [],
      bankName: "",
      bthStatus: false,
    };
  },
  created() {
    this.getBankList();
    this.getProductList();
  },
  computed: {
    getUser: function () {
      return JSON.parse(sessionStorage.getItem("user"));
    },
    getSourceType: function () {
      return sessionStorage.getItem("sourceType");
    },
  },
  methods: {
    none() {
      this.$message.error("请先阅读并同意信用承诺书");
    },
    apply(id) {
      if (id == 2) {
        this.$router.push("/xyd/SzzxdApply");
      } else if (id == 1) {
        // this.$router.push("/xyd/SznshApply");
        window.open("https://open.szrcb.com:9999/#/")
      } else {
        // this.$router.push("/xyd/sydApply")
        // this.$router.push({
        //   path: "/xyd/product_list_details",
        //   query: {
        //     id: id,
        //   },
        // });
        this.getSelectApplyCount(id);
      }
    },
    getProductList() {
      let params = {};
      applyApi.searchLoanProductList(this.sendParam(params)).then((res) => {
        res = this.paramDecrypt(res);
        console.log(res);
        if (res.code == 200) {
          this.seachList = res.data;
        }
      });
    },
    getSelectApplyCount(id) {
      let params = {
        id: id,
      };
      selectApplyCount(this.sendParam(params))
        .then((res) => {
          res = this.paramDecrypt(res);
          // console.log(res);
          if (res.code == 200) {
            if (res.data > 0) {
              this.bthStatus = true;
              this.getqueryProductHandlingInfo(id);
            }
          }
        })
        .catch((error) => {});
    },
    getqueryProductHandlingInfo(id) {
      let params = {
        productId: id,
      };
      queryProductHandlingInfo(this.sendParam(params)).then((res) => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.Name = res.data.productSpecialist;
          this.qrCode = res.data.qrCode;
          this.phone = res.data.phone;
          this.adressList = res.data.adressList;
          this.bankName = res.data.bankName;
        }
        this.success = true;
      });
    },
    handleClose() {
      this.success = false;
    },
    getBankList() {
      let params = {
        enterpriseCode: this.getUser.sstCustom.oucode,
      };
      applyApi
        .queryIsAuthByEnterpriseCode(this.sendParam(params))
        .then((res) => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.status = res.data;
          }
        });
    },
    // 选择金额区间
    banlaceChange(id) {
      this.selected = id;
      if (id == 0) {
        this.loanMinAmount = 0;
        this.loanMaxAmount = 100;
        if (this.checked) {
          if (this.status == 1) {
            this.onSubmit();
          } else if (this.status == 0) {
            this.$message.error("请先授权");
            sessionStorage.setItem("currentTab", "newAuth");
            this.$router.push("/xyd/my_center");
          }
        } else {
          this.$message.error("请阅读并同意信用承诺书");
        }
      } else if (id == 1) {
        this.loanMinAmount = 100;
        this.loanMaxAmount = 500;
        if (this.checked) {
          if (this.status == 1) {
            this.onSubmit();
          } else if (this.status == 0) {
            this.$message.error("请先授权");
            sessionStorage.setItem("currentTab", "newAuth");
            this.$router.push("/xyd/my_center");
          }
        } else {
          this.$message.error("请阅读并同意信用承诺书");
        }
      }
    },
    //同意承诺书
    agree() {
      this.dialogVisible = false;
      this.checked = true;
    },
    //确认申请
    async onSubmit() {
      if (this.selected != null) {
        let param = {
          loanMinAmount: this.loanMinAmount,
          loanMaxAmount: this.loanMaxAmount,
          status: "0",
        };
        const res = await applyApi.applyLoan(this.sendParam(param));
        let result = this.paramDecrypt(res);
        if (result.code == 202) {
          // this.$router.push({
          //   // path: "recommend_load",
          //   path: "apply_success",

          // })
          this.$message.error(result.msg);
        } else {
          this.$router.push({
            path: "apply_success",
          });
          this.$message.success(result.msg);
        }
      } else {
        this.$message.error("请选择贷款金额区间！");
      }
    },
    getSuccess() {
      this.successisShow = false;
      location.reload();
      // if (this.dataList.webUrl !== "" && this.dataList.webUrl != null) {
      //   window.open(this.dataList.webUrl, "_blank");
      // }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-checkbox {
  margin-right: 0px;
}
.applyLoan {
  background-color: #fff;
  .headImgs {
    img {
      width: 100%;
    }
  }
  .title {
    margin-top: 34px;
    text-align: center;
    img {
      width: 978px;
      height: 30px;
    }
    p {
      height: 21px;
      font-size: 22px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2a2a2a;
      line-height: 21px;
      margin-top: 16px;
    }
  }
  .main {
    text-align: center;
    margin-bottom: 76px;
    .btn_box {
      display: flex;
      justify-content: center;
      margin-top: 50px;
      margin-bottom: 43px;
      flex-direction: column;
      .select {
        width: 180px;
        height: 54px;
        background: #f8f8f8;
        border: 1px solid #2981ee;
        border-radius: 6px;
        font-size: 22px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2981ee;
        line-height: 54px;
        cursor: pointer;
        margin: 0 20px;
        text-align: center;
      }
      .item {
        width: 180px;
        height: 54px;
        background: #f8f8f8;
        border: 1px solid #d4d4d4;
        border-radius: 6px;
        font-size: 22px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #535353;
        line-height: 54px;
        cursor: pointer;
        margin: 0 20px;
        text-align: center;
      }
      .item:hover {
        border: 1px solid #2981ee;
        color: #2981ee;
      }
    }
    span {
      font-size: 14px;
      color: #2981ee;
      margin-left: 5px;
      cursor: pointer;
    }
    .check {
      width: 100%;
      height: 128px;
      margin-top: 63px;
      display: flex;
      justify-content: center;
      img {
        width: 370px;
        height: 128px;
      }
    }
    .bankList {
      margin: 20px auto;
      width: 1180px;
      height: 110px;
      background: #ffffff;
      border: 1px solid #d3d5dc;
      border-radius: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      .left {
        margin-left: 55px;
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
        }
        .text {
          margin-left: 8px;
          width: 151px;
          height: 22px;
          font-size: 22px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          line-height: 22px;
          white-space: nowrap;
          text-align: left;
        }
      }
      .right {
        display: flex;
        justify-content: space-between;
        margin-right: 40px;
        .child {
          width: 200px;
          display: flex;
          flex-direction: column;
          .top {
            font-size: 26px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #b90c1c;
          }
          .btn {
            font-size: 16px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            color: #595858;
            margin-top: 5px;
          }
        }
      }
    }
    .checked {
      width: 210px;
      height: 56px;
      background: #2981ee;
      box-shadow: 0px 8px 4px 0px rgba(0, 0, 0, 0.12);
      border-radius: 11px;
      font-size: 22px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #ffffff;
      line-height: 56px;
      margin: 35px auto 0 auto;
      cursor: pointer;
    }
    .unchecked {
      width: 210px;
      height: 56px;
      background: #d4d4d4;
      box-shadow: 0px 8px 4px 0px rgba(0, 0, 0, 0.12);
      border-radius: 11px;
      font-size: 22px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #535353;
      line-height: 56px;
      margin: 35px auto 0 auto;
    }
  }
  img {
    width: 100%;
  }
}
/deep/ .successdiolog .el-dialog__header{
  padding: 0 !important;
}

</style>